import React from "react";
import "../style/HomeSections.css";

const opportunities = [
  {
    name: "Giochi proprietari",
    tag: "Store",
    description:
      "In ogni scheda trovi subito se il gioco è gratis, in vendita o ancora in sviluppo."
  },
  {
    name: "Playtest interni",
    tag: "Test",
    description:
      "I test servono a rifinire i giochi, non a far sembrare finito qualcosa che non lo è."
  },
  {
    name: "Supporto leggibile",
    tag: "Supporto",
    description:
      "Account, launcher, acquisti e rimborsi hanno percorsi separati e facili da ritrovare."
  }
];

const productSnapshot = {
  quote:
    "Vogliamo che chi arriva sul sito capisca subito cosa può giocare oggi e cosa invece è ancora in lavorazione.",
  author: "Team Kyros Games",
  role: "Direzione prodotto"
};

export default function HomeProof() {
  return (
    <section className="home-proof">
      <div className="home-section__inner home-proof__inner">
        <div className="home-proof__testimonial">
          <span className="home-eyebrow">Direzione</span>
          <blockquote>
            <p>{productSnapshot.quote}</p>
            <footer>
              <strong>{productSnapshot.author}</strong>
              <small>{productSnapshot.role}</small>
            </footer>
          </blockquote>
          <a className="home-button home-button--primary home-proof__cta" href="/games">
            Vedi i giochi
          </a>
        </div>

        <div className="home-proof__grid" aria-label="Cosa conta per Kyros">
          {opportunities.map(item => (
            <article key={item.name} className="home-proof__card">
              <span className="home-proof__tag">{item.tag}</span>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
